export interface OperatorSession {
  userId: string
  email: string
  displayName: string
  status: 'ACTIVE' | 'PASSWORD_CHANGE_REQUIRED'
  /** Fiche Employé + rôle OPERATOR + compte actif (calculé par le serveur). */
  canOperate: boolean
  employeeId: string | null
}

export type AuthFailureCode =
  | 'INVALID_CREDENTIALS'
  | 'USER_INACTIVE'
  | 'SESSION_EXPIRED'
  | 'NOT_AN_OPERATOR'
  | 'ACCOUNT_SETUP_REQUIRED'
  | 'UNEXPECTED'

export class AuthFailure extends Error {
  constructor(
    public readonly code: AuthFailureCode,
    message: string,
  ) {
    super(message)
    this.name = 'AuthFailure'
  }
}
